import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomFormat, BackendMutationDeleteCustomFormatArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteCustomFormat($id: ID!) {
    deleteCustomFormat(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteCustomFormatArgs;
type Result = Pick<BackendCustomFormat, 'id'>;

export const deleteCustomFormat = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
